export default __webpack_public_path__ + "static/media/logo_GMX.b956aa96.svg";